import FeatureGates from "@atlassian/feature-gate-js-client";
import { ProductKeys } from "@atlassiansox/asc-stargate";

export const productRolloutExperimentMap: Partial<Record<ProductKeys, string>> =
    {
        [ProductKeys.CONFLUENCE]:
            "cross-flow_frontend_for_confluence_product_tour",
        [ProductKeys.JIRA_SOFTWARE]: "cross-flow_frontend_for_jira",
        [ProductKeys.JIRA_PRODUCT_DISCOVERY]:
            "cross-flow_frontend_for_jpd_product_tour"
    };

export const getRolloutFlagValue = (
    productKey?: ProductKeys,
    fireExperimentExposure?: boolean
) => {
    if (!productKey) {
        return "not-enrolled";
    }
    const experimentKey = productRolloutExperimentMap[productKey];
    if (!experimentKey) {
        return "not-enrolled";
    }
    return FeatureGates.getExperimentValue(
        experimentKey,
        "cohort",
        "not-enrolled",
        {
            fireExperimentExposure
        }
    );
};

export const WAC_GENERIC_TOUCHPOINT_NAME = "wacGenericCrossFlowTouchpoint";
export const WAC_GENERIC_TOUCHPOINT_COMPONENT_NAME =
    "wacGenericCrossFlowComponent";
